import React, {useState} from "react";
import {useLoaderData, useRevalidator} from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay, Show,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import client from "../../../helpers/Client";
import {AddIcon} from "@chakra-ui/icons";
import urlToId from "../../../helpers/UrlToId";

export async function Teamsloader() {
  const userData = JSON.parse(localStorage.getItem("user"));
  const reseller = userData.user.employee.reseller;
  const resp = await client.get(`/teams/?reseller=${urlToId(reseller.url)}`);
  return [resp.data]
}

export default function Teams() {
  const [name, setName] = useState(null)
  const revalidator = useRevalidator()
  const {isOpen, onOpen, onClose} = useDisclosure()
  const [teams] = useLoaderData();
  const userData = JSON.parse(localStorage.getItem("user"));
  const reseller = userData.user.employee.reseller;

  const handleCustomer = () => {
    const requestBody = {
      name: name, reseller: `${reseller.url}`
    };
    client
      .post(`/teams/`, requestBody)
      .then((response) => {
        onClose()
        setName("")
        revalidator.revalidate();
      })
      .catch((error) => {
      });
  }

  const columns = [{
    title: "Takım Adı", dataIndex: "name", render: (text, record) => (<Flex>
      <Text mt={3} as="b">{text}</Text>
    </Flex>),
  }, {
    title: "Üye sayısı", dataIndex: "member_count", render: (text, record) => (<Text as="b">
      {(text)}
    </Text>),
  }, ];
  return (<>
      <Card>
        <CardHeader>
          <Show above='sm'>
            <Box pos="absolute" right="0" top="0">
              <Button onClick={onOpen} rightIcon={<AddIcon/>} colorScheme='gray' variant='solid'>
                Takım Oluştur
              </Button>
            </Box>
          </Show>

        </CardHeader>
        <CardBody>
          <Text px={4} py={2} fontWeight="bold" fontSize="xl">
     Takımlar
          </Text>

          <TableContainer whiteSpace="wrap">
            <Table>
              {teams && teams.length > 0 ? (<>
                <Thead>
                  <Tr  fontSize="sm" fontWeight="semibold">
                    {columns.map((column) => (<Th key={column.dataIndex}>
                      <Text fontSize={16} textTransform="uppercase" fontWeight="bold">
                        {column.title}
                      </Text>
                    </Th>))}
                  </Tr>
                </Thead>
                <Tbody>
                  {teams.map((t) => (<Tr key={t.number}>
                    {columns.map((column) => (<Td key={column.dataIndex}>
                      {column.render ? (column.render(t[column.dataIndex], t)) : (<span>{t[column.dataIndex]}</span>)}
                    </Td>))}
                  </Tr>))}
                </Tbody>
              </>) : (<>
                <Text borderTop={"1px"} textAlign="center">Henüz oluşturulmuş bir servis kaydı yok</Text>
              </>)}
            </Table>
          </TableContainer>
          <Show below='sm'>
            <Box >
              <Button width={"full"} onClick={onOpen} rightIcon={<AddIcon/>} colorScheme='gray' variant='solid'>
                Takım Oluştur
              </Button>
            </Box>
          </Show>

        </CardBody>
      </Card>
      <Modal

        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay/>
        <ModalContent>
          <ModalHeader>Takım oluştur</ModalHeader>
          <ModalCloseButton/>
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Takım Adı</FormLabel>
              <Input value={name} onChange={(e) => setName(e.target.value)} placeholder=''/>
            </FormControl>

          </ModalBody>

          <ModalFooter>
            <Button onClick={handleCustomer} colorScheme='blue' mr={3}>
              Oluştur
            </Button>
            <Button onClick={onClose}>Vazgeç</Button>
          </ModalFooter>
        </ModalContent>
      </Modal></>);
}
